// extracted by mini-css-extract-plugin
export default {"open_on_upliance":"OpenOnUpliance_open_on_upliance__MuY8-","loader_container":"OpenOnUpliance_loader_container__7DRLY"};